export const NAVIGATION_ACTION = "navigationType" 

export const navigationType = (payload) => ({ 
    payload,
    type: NAVIGATION_ACTION
 })